import type { GameState, RoleId, ValidationResult } from "../types";
import { ROLE_DEFINITIONS } from "../types";
import { countRoles } from "../utils/role-rules";

export function validateHostAction(
  state: GameState,
  actorPlayerId: string,
  error: string,
): ValidationResult {
  if (actorPlayerId !== state.hostPlayerId) {
    return { valid: false, error };
  }
  return { valid: true };
}

export function validateSetupPhase(state: GameState): ValidationResult {
  if (state.phase !== "setup") {
    return { valid: false, error: "Action is only allowed during setup" };
  }
  return { valid: true };
}

export function validateRoleSelectionCount(
  state: GameState,
  roleIds: readonly RoleId[],
): ValidationResult {
  const expected = state.players.length + 3;
  if (roleIds.length !== expected) {
    return {
      valid: false,
      error: "Role count must equal player count plus three",
      details: { expected, actual: roleIds.length },
    };
  }
  return { valid: true };
}

export function validateRoleCopyLimits(
  roleIds: readonly RoleId[],
): ValidationResult {
  const counts = countRoles(roleIds);
  for (const [roleId, actual] of counts) {
    const definition = ROLE_DEFINITIONS[roleId];
    if (!definition) {
      return {
        valid: false,
        error: "Unknown role",
        details: { roleId },
      };
    }
    if (actual > definition.maxCopies) {
      return {
        valid: false,
        error: "Too many copies of role",
        details: { roleId, maxCopies: definition.maxCopies, actual },
      };
    }
  }
  return { valid: true };
}
